import axios from "axios";
import { getAccessToken } from "./authSession";
import { API_BASE_URL } from "../config";

// Ценообразование площадок (Prom / Rozetka / Kasta): один API на все платформы.
const base = (platform, accountId) =>
    `${API_BASE_URL}/integrations/marketplaces/${platform}/accounts/${accountId}/pricing`;

const auth = () => ({ headers: { Authorization: `Bearer ${getAccessToken()}` } });

export const getPricingSettings = async (platform, accountId) =>
    (await axios.get(`${base(platform, accountId)}/settings`, auth())).data;

export const savePricingSettings = async (platform, accountId, payload) =>
    (await axios.put(`${base(platform, accountId)}/settings`, payload, auth())).data;

export const getPriceRules = async (platform, accountId, params = {}) =>
    (await axios.get(`${base(platform, accountId)}/rules`, { ...auth(), params })).data;

export const createPriceRule = async (platform, accountId, payload) =>
    (await axios.post(`${base(platform, accountId)}/rules`, payload, auth())).data;

export const bulkPriceRules = async (platform, accountId, items) =>
    (await axios.post(`${base(platform, accountId)}/rules/bulk`, { items }, auth())).data;

export const patchPriceRule = async (platform, accountId, ruleId, payload) =>
    (await axios.patch(`${base(platform, accountId)}/rules/${ruleId}`, payload, auth())).data;

export const searchBrands = async (platform, accountId, q) =>
    (await axios.get(`${base(platform, accountId)}/brands`, { ...auth(), params: { q, limit: 20 } })).data;

export const previewPricing = async (platform, accountId, productCodes, simulate = null) =>
    (await axios.post(
        `${base(platform, accountId)}/preview`,
        simulate ? { product_codes: productCodes, simulate } : { product_codes: productCodes },
        auth(),
    )).data;
